import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createChangeEmailOutbound } from '../../api/outbound/commonOutbounds';
import { useInstanceId } from '../../context/instance/instanceContext';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { PanelItem } from '../../panels/panelItem';
import { thunkCloseCurrentMessageBox } from '../../redux/actions/messageBoxesActions';
import { addToast, thunkCloseToast } from '../../redux/actions/toastsActions';
import { useAppDispatch } from '../../redux/store';
import { CHANGE_EMAIL_TOAST_KEY } from '../../types/toastTypes';
import { FormControlContainer } from '../formControlContainer';
import { OpenModalContainer } from '../openModalContainer';
import { ValueDisplay } from '../valueDisplay';
import { GoToAccountModalHeaderButton } from './goToAccountModalHeaderButton';
export const ChangeEmailModal = ({ currentEmail, onClose }) => {
    const dispatch = useAppDispatch();
    const instanceId = useInstanceId();
    const socketSend = useSocketSend();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [newEmailConfirmation, setNewEmailConfirmation] = useState('');
    const onClickUpdate = useCallback(() => {
        dispatch(thunkCloseToast(CHANGE_EMAIL_TOAST_KEY));
        if (!currentPassword) {
            dispatch(addToast({
                type: 'change-email-error',
                key: CHANGE_EMAIL_TOAST_KEY,
                message: 'Your current password is required.'
            }));
            return;
        }
        if (!newEmail) {
            dispatch(addToast({
                type: 'change-email-error',
                key: CHANGE_EMAIL_TOAST_KEY,
                message: 'Enter a new email.'
            }));
            return;
        }
        if (newEmail !== newEmailConfirmation) {
            dispatch(addToast({
                type: 'change-email-error',
                key: CHANGE_EMAIL_TOAST_KEY,
                message: 'Your email confirmation does not match.'
            }));
            return;
        }
        socketSend(createChangeEmailOutbound(newEmail, currentPassword));
        dispatch(thunkCloseCurrentMessageBox());
    }, [currentPassword, dispatch, newEmail, newEmailConfirmation, socketSend]);
    const onChangeNewEmail = (event) => {
        setNewEmail(event.target.value);
    };
    const onChangeNewEmailConfirmation = (event) => {
        setNewEmailConfirmation(event.target.value);
    };
    const onChangeCurrentPassword = (event) => {
        setCurrentPassword(event.target.value);
    };
    return (_jsx(OpenModalContainer, { title: 'Change Email', onClose: onClose, additionalControls: _jsx(GoToAccountModalHeaderButton, { onClose: onClose }), children: _jsxs(DialogContent, { children: [_jsx(PanelItem, { children: _jsx(ValueDisplay, { label: 'Current Email', value: currentEmail, isLabelFirst: true }) }), _jsxs(FormControlContainer, { children: [_jsx(TextField, { id: `new-email-${instanceId}`, variant: 'filled', fullWidth: true, label: 'New Email', value: newEmail, onChange: onChangeNewEmail }), _jsx(TextField, { id: `confirm-new-email-${instanceId}`, variant: 'filled', fullWidth: true, label: 'Confirm New Email', value: newEmailConfirmation, onChange: onChangeNewEmailConfirmation })] }), _jsx(FormControlContainer, { children: _jsx(TextField, { id: `current-password-${instanceId}`, type: 'password', variant: 'filled', fullWidth: true, label: 'Current Password', value: currentPassword, onChange: onChangeCurrentPassword }) }), ' ', _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickUpdate, children: "Update Email" }) })] }) }));
};
